import React from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import './ContentPane.css';
import {
  ON_TAB_SELECTION, ON_TAB_CLOSE, ON_TAB_RENAME, ON_TAB_MOVE,
} from '../../actions/tab';

class ContentPane extends React.Component {
  buildTab(tab, tabs, index) {
    const { dispatch, } = this.props;
    const { requestedState, } = tab;

    return (
      <Tab
        key={tab.key}
        name={tab.tabName}
        onMouseDown={() => dispatch({ type: ON_TAB_SELECTION, selectedTab: tab, })}
        onClose={() => dispatch({ type: ON_TAB_CLOSE, closingTab: tab, })}
        onRename={() => dispatch({ type: ON_TAB_RENAME, selectedTab: tab, })}
        onMove={(draggedIndex, targetIndex) => this.handleTabMove(draggedIndex, targetIndex, tabs)}
        isTabActive={this.isSelectedTab(tab)}
        tabIndex={index}
        view={tab.getView({ requestedState, })}
        tabs={tabs}
      />
    );
  }

  handleTabMove(draggedIndex, targetIndex, tabs) {
    const { dispatch, } = this.props;
    dispatch({ type: ON_TAB_MOVE, draggedIndex, targetIndex, });
    dispatch({ type: ON_TAB_SELECTION, selectedTab: tabs[draggedIndex], }); // navigate to the tab that was moved
  }

  formatTabs({ tabs, }) {
    if (!tabs) {
      return [];
    }

    return tabs.map((tab, index) => this.buildTab(tab, tabs, index));
  }

  isSelectedTab(tab) {
    const { selectedTab = {}, } = this.props;
    return selectedTab.key === tab.key;
  }

  render() {
    const tabs = this.formatTabs(this.props);
    return (
      <div className="content-pane">
        <ul className="nav nav-tabs">
          {tabs}
          <li
            className="nav-item drop-zone"
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              const draggedTabIndex = e.dataTransfer.getData('text/plain');
              this.handleTabMove(draggedTabIndex, tabs.length);
            }}
          />
        </ul>
        {tabs.map(tab => (
          <div className={this.isSelectedTab(tab) ? 'selected-tab' : 'hidden'} key={tab.key}>
            {tab.props.view}
          </div>
        ))}
      </div>
    );
  }
}

ContentPane.defaultProps = {
  selectedTab: undefined,
};

ContentPane.propTypes = {
  selectedTab: PropTypes.instanceOf(Object),
  dispatch: PropTypes.instanceOf(Function).isRequired,
};

export default ContentPane;
